import { useRef, useState, useEffect } from 'react'
import { useNavigate, Outlet, useLocation } from 'react-router-dom'
import localForage from "localforage";
import home from '../img/home.svg'
import playlist from '../img/ico-main-play-setting.svg'
import playlistDisabled from '../img/ico-main-play-settingDisabled.svg'
import strings from '../strings.js'
import { SendMessage } from '../App.js';
import SelectingControlCard from '../SelectingControlCard';

export function Footer({stateVer, tableNo, lang, statePlaybackUserId, stateDuration, hasReplayed, setHasReplayed, micEnabled}) {



  const myRef = useRef(null)

  const executeScroll = () => myRef.current.scrollIntoView()    
  // run this function from an event handler or an effect to execute scroll 

  const [timer, setTimer] = useState(null);
  const handleStart = () => {
    setTimer(setTimeout(() => {
        executeScroll();
        localForage.setItem("table", null).then(
          navigate("/tableNo", {replace:true})
        )
    }, 5000));
  };

  const handleEnd = () => {
    clearTimeout(timer);
  };


  const navigate = useNavigate();
  const location = useLocation();

  const [selectingControl, setSelectingControl] = useState(false);

  function goInControls() {
    /*
    if (statePlaybackUserId === "50")
    {
      setSelectingControl(true)
    }
    else if(statePlaybackUserId === JSON.parse(localStorage.getItem("sn")))
    {
      setSelectingControl(true)
    }
    else {
      return;
    }*/
      setSelectingControl(true)
  }

  useEffect(()=> {
    if(statePlaybackUserId != JSON.parse(localStorage.getItem("sn")))
    {
      setSelectingControl(false)
    }
}, [statePlaybackUserId])

  return (
    <>
      <div className="fodoter">
        <a
        onTouchStart={handleStart}
        onTouchEnd={handleEnd}
        onMouseDown={handleStart}
        onMouseUp={handleEnd}
        onClick={(e) => {
          e.preventDefault();
          executeScroll();
          navigate("/home", { replace: true });
        }}
        >
        
        <img
            src={home}
            alt="home"            
        />
        </a>

        <div className="fodoter-mid" onClick={(e) => {e.preventDefault();
          if (stateVer==="dating") {
            navigate("/home/overview")
          }
        }}>
          {stateVer==="dating" && (lang ? strings.cn.table : strings.en.table) + " "  + tableNo}
        </div>
        <a onClick={(e) => {e.preventDefault(); goInControls();}}>
        <img
            src={playlist}
            alt="home"
            ref={myRef}           
        />
        </a>
    </div>
    { selectingControl && (
        <>
        <SelectingControlCard onClick={() => { setSelectingControl(false);}} statePlaybackUserId={statePlaybackUserId} hasReplayed={hasReplayed} setHasReplayed={setHasReplayed} stateVer={stateVer} tableNo={tableNo} lang={lang} stateDuration={stateDuration} micEnabled={micEnabled}/>
        </>
    )}

    <Outlet/>
    </>
  )
  }
